import { PostgrestSingleResponse } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';

import { supabase } from '../api';

type HashtagType = {
  id: number,
  label: string,
  publicationsCount: any,
}

type HashtagDataType = {
  page: number,
  limit: number,
  pageCount: number,
  items: HashtagType[],
}

const getHashtags = async (page: number, limit: number): Promise<HashtagDataType> => {
  // @ts-ignore
  const { data, count, error }: PostgrestSingleResponse<HashtagType[]> = await supabase
    .from('hashtags')
    .select(
      '*, publicationsCount:hashtags_posts (count)',
      { count: 'exact' },
    )
    .order('label', { ascending: true })
    .range(page * limit, (page * limit) + limit - 1);

  if (error) {
    throw new Error(error.message);
  }

  return {
    page,
    limit,
    pageCount: Math.ceil((count || 0) / (limit || 1)) || 0,
    items: data.map((v) => ({ ...v, publicationsCount: v.publicationsCount?.[0]?.count || 0 })),
  };
};

export default function useHashtags(page = 0, limit = 10) {
  return useQuery({
    queryKey: ['hashtags', page, limit],
    queryFn: () => getHashtags(page, limit),
    staleTime: 0,
    cacheTime: 0,
  });
}
